import "./JobDescription.scss";
import { AssessmentButton, showToast } from "ui-components";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Header from "../../../components/Assessment/Header/Header";
import Footer from "../../../components/Footer/Footer";
import {
  companyGetJobDetails,
  createJob,
} from "../../../service/CvScanning/CvScanning";
import { useNavigate } from "react-router-dom";
import Loader from "../../../components/Loader/Loader";
import ScanningDetails from "./ScanningDetails/ScanningDetails";
import { removeSessionStorageItem } from "../../../utils/SessionStorageMethod/removeSessionStorageItem";
import { scrollWindowTop } from "../../../utils/Common/Constant";

const JobDescription = () => {
  const { i18n, t } = useTranslation();
  const currentLanguage = i18n.language;
  const jobId = new URLSearchParams(location.search).get("jobId");
  const navigate = useNavigate();
  const scanningDetailsRef = useRef<any>(null);
  const [jobDetailsData, setJobDetailsData] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [draftLoading, setDraftLoading] = useState(false);
  const scrollToNextSec = useRef<any>(null);
  // invoke when edit jobs
  useEffect(() => {
    if (jobId) {
      const getJobDetails = async () => {
        const jobDetailsRes = await companyGetJobDetails(jobId);
        if (jobDetailsRes?.status === 200) {
          // setDescription(jobDetailsRes?.data?.description);
          setJobDetailsData(jobDetailsRes?.data);
          // setIsJobScanning(true);
        }
      };
      getJobDetails();
    }
    scrollWindowTop();
  }, []);
  // function to create job
  const handleCreateJob = async (status: string) => {
    if (scanningDetailsRef.current?.isTitleEmpty()) {
      scanningDetailsRef.current?.scrollToTop();
      scanningDetailsRef.current?.focusTitleInput();
    } else if (!scanningDetailsRef.current?.validateBudget()) {
      return;
    } else if (!scanningDetailsRef.current?.validateShiftTime()?.isValid) {
      showToast(
        scanningDetailsRef.current?.validateShiftTime()?.errorMessage,
        "error",
      );
      return;
    } else {
      if (status === "Draft") {
        setDraftLoading(true);
      } else {
        setLoading(true);
      }
      const updatedData = scanningDetailsRef?.current?.getUpdatedData(status);
      const updateJobsRes = await createJob(updatedData);
      if (updateJobsRes?.status === 200) {
        setLoading(false);
        removeSessionStorageItem("jobDetailsData");
        removeSessionStorageItem("job-keywords");
        removeSessionStorageItem("isJobScanning");
        removeSessionStorageItem("jdText");
        removeSessionStorageItem("maximumExperience");
        removeSessionStorageItem("minimumExperience");
        removeSessionStorageItem("openPositions");
        removeSessionStorageItem("jobMutipleAddress");
        sessionStorage.setItem("navigateFromView", "true");
        if (status === "Draft") {
          showToast(t("GENERAL.JOB_SAVE_AS_DRAFT"), "success");
          navigate(`/${currentLanguage}/jobs?st=Draft`);
        } else {
          showToast(updateJobsRes?.customMessage, "success");
          navigate(`/${currentLanguage}/job/${updateJobsRes?.data?.jobId}`);
        }
      } else {
        setLoading(false);
        setDraftLoading(false);
      }
    }
  };
  return (
    <>
      <Header />
      <div className="container-fluid jobDescription minHeight100">
        <h2 className="mt-5 mb-4">{t("RESUME.SCANNING_CREATE_NEW_JOB")}</h2>
        <div className="jdWork row">
          <div className="jobScanDetails">
            <ScanningDetails
              scrollingRef={scrollToNextSec}
              ref={scanningDetailsRef}
              jobDetailsData={jobDetailsData}
            />
          </div>
          <div className="jdPopupFooter mt-3 mb-3 justify-content-end">
            <div className="saveBtn draftSaveBtn">
              {(jobDetailsData?.status === "Draft" || !jobId) && (
                <AssessmentButton
                  disabled={draftLoading}
                  className={"saveDraftButton"}
                  onClick={() => {
                    handleCreateJob("Draft");
                  }}
                >
                  {draftLoading ? (
                    <div className="scanJobLoader">
                      <p>{t("GENERAL.PROCESSING")}</p>
                      <Loader />
                    </div>
                  ) : jobId ? (
                    t("GENERAL.UPDATE_DRAFT")
                  ) : (
                    t("GENERAL.SAVE_AS_DRAFT")
                  )}
                </AssessmentButton>
              )}
              <div>
                <AssessmentButton
                  disabled={loading}
                  onClick={() => {
                    handleCreateJob("Active");
                  }}
                >
                  {loading ? (
                    <div className="scanJobLoader">
                      <p>{t("GENERAL.PROCESSING")}</p>
                      <Loader />
                    </div>
                  ) : (
                    t("GENERAL.PUBLISH")
                  )}
                </AssessmentButton>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default JobDescription;
